import { logger } from '../utils/logger';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { activar, findAll, get, remove, save, update } from "../services/Service";

import { EmpresaSupervisora, EmpresaSupervisoraFiltro } from "../types/EmpresaSupervisora";
import {
    addEmpresaSupervisora,
    loadDataEmpresaSupervisora,
    loadListEmpresaSupervisora,
    loadingError,
    visibleError,
    setGuardado,
    loadDataFiltro,
    empresaSupervisoraInitial,
    empresaSupervisoraFiltroInitial,
} from "../context/EmpresaSupervisora/EmpresaSupervisoraReducer";

export const useEmpresaSupervisora = () => {
    const BASE_URL = 'empresasSupervisoras';
    const { loading, empresaSupervisoraSelected, empresaSupervisoraList, errors, error, guardado, filtro } = useSelector(
        (state: RootState) => state.empresaSupervisora
    );

    const dispatch = useDispatch();

    const buscarEmpresasSupervisoras = async (filtroEmpresaSupervisora: EmpresaSupervisoraFiltro) => {
        const params: string[] = [];
        if (filtroEmpresaSupervisora.idEmpresaSupervisora !== null && filtroEmpresaSupervisora.idEmpresaSupervisora !== '' && filtroEmpresaSupervisora.idEmpresaSupervisora !== 0) {
            params.push(`idEmpresaSupervisora=${filtroEmpresaSupervisora.idEmpresaSupervisora}`);
        }
        if (filtroEmpresaSupervisora.activo !== null && filtroEmpresaSupervisora.activo !== '') {
            params.push(`activo=${filtroEmpresaSupervisora.activo}`);
        }
        const url = `${BASE_URL}/buscar${params.length > 0 ? '?' + params.join('&') : ''}`;

        try {
            const response = await findAll(url);
            dispatch(loadListEmpresaSupervisora(response.data));
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const guardarEmpresaSupervisora = async (empresaSupervisora: EmpresaSupervisora) => {
        let response;
        try {
            if (!empresaSupervisora.id) {
                response = await save(BASE_URL, empresaSupervisora);
            } else {
                response = await update(BASE_URL, empresaSupervisora);
            }
            dispatch(addEmpresaSupervisora(response.data));
            return response;
        } catch (error: any) {
            throw error;
        }
    }

    const buscarEmpresaSupervisora = async (id: string) => {
        try {
            const response = await get(BASE_URL, id)
            dispatch(loadDataEmpresaSupervisora(response.data));

            return response.data;
        } catch (error) {
            logger.log(error);
        }
    }

    const eliminarEmpresaSupervisora = async (id: string) => {
        try {
            const response = await remove(BASE_URL, id)
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const activarEmpresaSupervisora = async (id: string) => {
        try {
            const response = await activar(BASE_URL, id)
            return response;
        } catch (error) {
            logger.log(error);
            throw error;
        }
    }

    const handleEmpresaSupervisoraSelected = (empresaSupervisora: EmpresaSupervisora) => {
        dispatch(loadDataEmpresaSupervisora(empresaSupervisora))
    }
    const showError = (load: boolean) => {
        dispatch(visibleError(load))
    }
    const setMsgError = (error: string[]) => {
        dispatch(loadingError(error));
    }
    const handleGuardado = (guardado: boolean) => {
        dispatch(setGuardado(guardado))
    }
    const handleFiltroEmpresaSupervisora = (filtroEmpresaSupervisora: EmpresaSupervisoraFiltro) => {
        dispatch(loadDataFiltro(filtroEmpresaSupervisora))
    }
    return {
        buscarEmpresasSupervisoras,
        guardarEmpresaSupervisora,
        buscarEmpresaSupervisora,
        eliminarEmpresaSupervisora,
        activarEmpresaSupervisora,
        handleEmpresaSupervisoraSelected,
        showError,
        setMsgError,
        handleGuardado,
        handleFiltroEmpresaSupervisora,
        filtro,
        empresaSupervisoraInitial,
        empresaSupervisoraFiltroInitial,
        empresaSupervisoraList,
        empresaSupervisoraSelected,
        loading,
        errors,
        error,
        guardado
    }
}
